import { clarify } from '@/domain/services/VueDataProvider';
import { getGlobal } from '@/lib/utils';

const defaultState = () => ({
	validationErrors: getGlobal('validationErrors') ? clarify(getGlobal('validationErrors')) : {},
	formError: null,
});

const state = defaultState();

export default state;
export { defaultState };
